export default __webpack_public_path__ + "static/media/bannerIllustration.2532588f.png";